var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2563 13.8906C10.445 14 10.6423 14.0273 10.8482 13.9726C11.0541 13.9179 11.2128 13.7949 11.3243 13.6035C11.4358 13.4121 11.4744 13.207 11.4401 12.9883L10.7967 8.99607L13.5247 6.17967C13.6791 6.01561 13.7606 5.8242 13.7692 5.60546C13.7777 5.38671 13.7177 5.18619 13.589 5.00389C13.4603 4.8216 13.2845 4.71223 13.0614 4.67577L9.30409 4.10155L7.6313 0.492186C7.52836 0.273437 7.37824 0.127604 7.18093 0.0546875C6.98363 -0.0182292 6.78633 -0.0182292 6.58902 0.0546875C6.39172 0.127604 6.2416 0.273437 6.13866 0.492186L4.46587 4.10155L0.708523 4.67577C0.485484 4.71223 0.309627 4.8216 0.180951 5.00389C0.0522747 5.18619 -0.00777408 5.38671 0.000804204 5.60546C0.00938248 5.8242 0.0908775 6.01561 0.245289 6.17967L2.97322 8.99607L2.32984 12.9883C2.29553 13.207 2.33413 13.4121 2.44565 13.6035C2.55717 13.7949 2.71587 13.9179 2.92175 13.9726C3.12764 14.0273 3.32494 14 3.51366 13.8906L6.88498 12.0312L10.2563 13.8906Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.e964617188872b3f486ef2447230387b.svg";
export { ForwardRef as ReactComponent };